var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "filter-inputs-summary" }, [
    _c(
      "p",
      {
        staticClass:
          "form-control-static filter-inputs-summary__tag-id clickable",
        on: {
          click: function($event) {
            return _vm.enableEditView()
          }
        }
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm._f("tagIdToText")(_vm.criteria.tagId, _vm.availableTags)
            ) +
            "\n  "
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticClass:
          "form-control-static filter-inputs-summary__comparison clickable",
        on: {
          click: function($event) {
            return _vm.enableEditView()
          }
        }
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm._f("camelCaseFormat")(_vm.criteria.comparisonTypeTemp.value)
            ) +
            "\n  "
        )
      ]
    ),
    _vm._v(" "),
    _vm.isArray(_vm.criteria.value)
      ? _c(
          "div",
          {
            staticClass:
              "form-control-static filter-inputs-summary__value states-summary",
            on: {
              click: function($event) {
                return _vm.enableEditView()
              }
            }
          },
          _vm._l(_vm.sort(_vm.criteria.value), function(state, index) {
            return _c("strong", { key: state, staticClass: "clickable" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.getStateValue(_vm.criteria.tagId, state)) +
                  "\n      "
              ),
              index == _vm.items.length - 1
                ? _c("span", { staticClass: "text-muted divider" }, [
                    _vm._v("|")
                  ])
                : _vm._e()
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isArray(_vm.criteria.value)
      ? _c(
          "div",
          {
            staticClass:
              "form-control-static filter-inputs-summary__value filter-inputs-summary__value--selected clickable",
            on: {
              click: function($event) {
                return _vm.enableEditView()
              }
            }
          },
          [
            _vm.criteria.isBulkTag && _vm.criteria.hasMultipleValues
              ? _c(
                  "i",
                  {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "BULK_TAGS_TEXT",
                        expression: "'BULK_TAGS_TEXT'"
                      }
                    ]
                  },
                  [_vm._v(":")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.criteria.value))])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isReadOnly
      ? _c(
          "a",
          {
            staticClass: "btn btn-function filter-item-edit",
            on: {
              click: function($event) {
                return _vm.enableEditView()
              }
            }
          },
          [_c("i", { staticClass: "typcn typcn-edit" })]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }